import { isAxiosError } from 'axios';

// The backend's own reason (e.g. "at least one caregiver must remain unblocked"), if it sent one.
export const getErrorMessage = (error: unknown): string | undefined => {
  if (!isAxiosError(error)) return undefined;
  const message = (error.response?.data as { message?: unknown } | undefined)?.message;
  return typeof message === 'string' && message ? message : undefined;
};
